export const CARD_TYPES = {
    IMAGE: 'IMAGE',
    TEXT: 'TEXT',
}
